import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import config from '../../config/config';

function DASHBOARD_USER_PROFILE() {
  const { API_BASE_URL } = config;

  const [user, setUser] = useState({
    firstname: '',
    lastname: '',
    email: '',
    mobile: '',
    gender: '',
  });
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // load user from localStorage
  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem('auth'));
    if (auth) {
      setUser(auth);
    }
  }, []);
  console.log(user);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!oldPassword || !newPassword) return;

    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/Changepswd`, {
        email: user.email,
        oldPassword: oldPassword,
        password: newPassword,
      });

      toast.success(response.data || 'Password changed successfully');
      setOldPassword('');
      setNewPassword('');
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-6 space-y-6">
      {/* Profile Header */}
      <div className="bg-white border rounded-xl p-6 flex items-center gap-6">
        <div className="w-16 h-16 rounded-full bg-blue-600 text-white flex items-center justify-center text-xl font-bold">
          {user.firstname?.charAt(0) || 'U'}
        </div>
        <div>
          <h2 className="text-xl font-semibold text-gray-800">
            {user.firstname} {user.lastname}
          </h2>
          <p className="text-sm text-gray-500">{user.email}</p>
          <p className="text-sm text-gray-500">Mobile: {user.mobile}</p>
          <p className="text-sm text-gray-500">Gender: {user.gender}</p>
        </div>
      </div>

      {/* Account Security */}
      <div className="bg-white border rounded-xl">
        <div className="p-6 border-b">
          <h3 className="text-lg font-semibold text-gray-900">Account Security</h3>
          <p className="text-sm text-gray-500 mt-1">
            Update your password to keep your account secure
          </p>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium mb-1">Current Password</label>
              <input
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                className="w-full rounded-lg border border-gray-300 p-2.5 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full rounded-lg border border-gray-300 p-2.5 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
          </div>

          <div className="flex justify-end pt-4 border-t">
            <button
              type="submit"
              disabled={loading}
              className="rounded-lg bg-blue-600 px-6 py-2.5 text-white hover:bg-blue-700 disabled:opacity-60"
            >
              {loading ? 'Updating...' : 'Change Password'}
            </button>
          </div>
        </form>
      </div>

      <ToastContainer />
    </div>
  );
}

export default DASHBOARD_USER_PROFILE;




// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import config from '../../config/config';

// function DASHBOARD_USER_PROFILE() {
//     const { API_BASE_URL } = config;

//     const [loggedInUser, setLoggedInUser] = useState({ name: '', email: '' });
//     const [oldPassword, setOldPassword] = useState('');
//     const [newPassword, setNewPassword] = useState('');
//     const [loading, setLoading] = useState(false);

//     // ✅ Load user info from localStorage on page load
//     useEffect(() => {
//         const user = localStorage.getItem('user');
//         if (user) {
//             setLoggedInUser(JSON.parse(user));
//         }
//     }, []);

//     // Optional: Fetch latest user data from API
//     // useEffect(() => {
//     //     const fetchProfile = async () => {
//     //         try {
//     //             const token = JSON.parse(localStorage.getItem('user'))?.token;
//     //             if (!token) return;
//     //             const res = await axios.get(`${API_BASE_URL}/auth/profile`, {
//     //                 headers: { Authorization: `Bearer ${token}` },
//     //             });
//     //             setLoggedInUser(res.data);
//     //         } catch (err) {
//     //             console.error('Failed to fetch profile:', err);
//     //         }
//     //     };
//     //     fetchProfile();
//     // }, []);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!oldPassword || !newPassword) return;

//         setLoading(true);
//         try {
//             const response = await axios.post(`${API_BASE_URL}/auth/Changepswd`, {
//                 email: loggedInUser.email,
//                 oldpassword: oldPassword,
//                 password: newPassword,
//             });

//             toast.success(response.data?.message || 'Password changed successfully');
//             setOldPassword('');
//             setNewPassword('');
//         } catch (error) {
//             toast.error(error.response?.data?.message || 'Failed to change password');
//             console.error(error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="max-w-5xl mx-auto p-6 space-y-6">
//             {/* Profile Header */}
//             <div className="bg-white border rounded-xl p-6 flex items-center gap-6">
//                 <div className="w-16 h-16 rounded-full bg-blue-600 text-white flex items-center justify-center text-xl font-bold">
//                     {loggedInUser.name.charAt(0) || 'U'}
//                 </div>
//                 <div>
//                     <h2 className="text-xl font-semibold text-gray-800">
//                         {loggedInUser.name || 'User'}
//                     </h2>
//                     <p className="text-sm text-gray-500">
//                         {loggedInUser.email || 'email@example.com'}
//                     </p>
//                 </div>
//             </div>

//             {/* Account Settings */}
//             <div className="bg-white border rounded-xl">
//                 <div className="p-6 border-b">
//                     <h3 className="text-lg font-semibold text-gray-900">
//                         Account Security
//                     </h3>
//                     <p className="text-sm text-gray-500 mt-1">
//                         Update your password to keep your account secure
//                     </p>
//                 </div>

//                 <form onSubmit={handleSubmit} className="p-6 space-y-6">
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">
//                                 Current Password
//                             </label>
//                             <input
//                                 type="password"
//                                 className="w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm focus:ring-blue-500 focus:border-blue-500"
//                                 value={oldPassword}
//                                 onChange={(e) => setOldPassword(e.target.value)}
//                                 required
//                             />
//                         </div>

//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">
//                                 New Password
//                             </label>
//                             <input
//                                 type="password"
//                                 className="w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm focus:ring-blue-500 focus:border-blue-500"
//                                 value={newPassword}
//                                 onChange={(e) => setNewPassword(e.target.value)}
//                                 required
//                             />
//                         </div>
//                     </div>

//                     <div className="flex justify-end pt-4 border-t">
//                         <button
//                             type="submit"
//                             disabled={loading}
//                             className="rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 disabled:opacity-60"
//                         >
//                             {loading ? 'Updating...' : 'Change Password'}
//                         </button>
//                     </div>
//                 </form>
//             </div>

//             <ToastContainer />
//         </div>
//     );
// }

// export default DASHBOARD_USER_PROFILE;
